function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ReactDOM from 'react-dom';
import { PanButton } from './PanButton';
import { showResetPopup } from '../../MapResetPopup';
import { ThemeProvider } from 'oskari-ui/util/contexts';

/**
 * @class Oskari.mapframework.bundle.mapmodule.plugin.PanButtons
 * Adds on-screen pan buttons on the map. In the middle of the pan buttons is a
 * state reset button.
 *
 * See http://www.oskari.org/trac/wiki/DocumentationBundleMapModulePluginPanButtons
 */
Oskari.clazz.define('Oskari.mapframework.bundle.mapmodule.plugin.PanButtons',
/**
 * @static @method create called automatically on construction
 *
 *
 */
function () {
  this._clazz = 'Oskari.mapframework.bundle.mapmodule.plugin.PanButtons';
  this._defaultLocation = 'top right';
  this._index = 20;
  this._name = 'PanButtons';
  this._panPxs = 100;
  this.showArrows = !!this.getConfig().showArrows;
  this.resetPopup = null;
}, {
  /**
   * @private @method _createControlElement
   * Draws the panbuttons on the screen.
   *
   *
   * @return {jQuery}
   * Plugin jQuery element
   */
  _createControlElement: function _createControlElement() {
    var el = jQuery('<div class="mapplugin panbuttonDiv panbuttons"></div>');
    return el;
  },
  clearPopup: function clearPopup() {
    if (this.resetPopup) {
      this.resetPopup.close();
    }
    this.resetPopup = null;
  },
  _resetClicked: function _resetClicked() {
    var _this = this;
    if (this.resetPopup) return;
    var cb = function cb() {
      if (_this.getSandbox().hasHandler('StateHandler.SetStateRequest')) {
        _this.getSandbox().postRequestByName('StateHandler.SetStateRequest');
      } else {
        _this.getSandbox().resetState();
      }
    };
    this.resetPopup = showResetPopup(function () {
      return cb();
    }, function () {
      return _this.clearPopup();
    });
  },
  _panClicked: function _panClicked(x, y) {
    var pxX = this._panPxs * x;
    var pxY = this._panPxs * y;
    this.getMapModule().panMapByPixels(pxX, pxY, true);
  },
  refresh: function refresh() {
    var _this2 = this;
    var el = this.getElement();
    if (!el) {
      return;
    }
    ReactDOM.render(/*#__PURE__*/React.createElement(ThemeProvider, {
      value: this.getMapModule().getMapTheme()
    }, /*#__PURE__*/React.createElement(PanButton, {
      resetClicked: function resetClicked() {
        return _this2._resetClicked();
      },
      panClicked: function panClicked(x, y) {
        return _this2._panClicked(x, y);
      },
      isMobile: Oskari.util.isMobile(),
      showArrows: this.showArrows
    })), el[0]);
  },
  /**
   * Handle plugin UI and change it when desktop / mobile mode
   * @method  @public createPluginUI
   * @param  {Boolean} mapInMobileMode is map in mobile mode
   * @param {Boolean} forced application has started and ui should be rendered with assets that are available
   */
  redrawUI: function redrawUI(mapInMobileMode, forced) {
    if (!this.isVisible()) {
      // no point in drawing the ui if we are not visible
      return;
    }

    // don't do anything now if request is not available.
    // When returning false, this will be called again when the request is available
    this.teardownUI();
    this._element = this._createControlElement();
    this.refresh();
    this.addToPluginContainer(this._element);
  },
  teardownUI: function teardownUI() {
    this.removeFromPluginContainer(this.getElement());
  },
  /**
   * @method _stopPluginImpl BasicMapModulePlugin method override
   * @param {Oskari.Sandbox} sandbox
   */
  _stopPluginImpl: function _stopPluginImpl(sandbox) {
    this.teardownUI();
  },
  /**
   * @method setShowArrows
   * @param {Boolean} showArrows
   */
  setShowArrows: function setShowArrows(showArrows) {
    this.setConfig(_objectSpread(_objectSpread({}, this.getConfig()), {}, {
      showArrows: !!showArrows
    }));
    this.showArrows = !!showArrows;
    this.refresh();
  }
}, {
  'extend': ['Oskari.mapping.mapmodule.plugin.BasicMapModulePlugin'],
  /**
   * @static @property {string[]} protocol array of superclasses
   */
  'protocol': ['Oskari.mapframework.module.Module', 'Oskari.mapframework.ui.module.common.mapmodule.Plugin']
});